var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/insta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.7089109%",
    x2: "50%",
    y2: "0.776721582%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C74C4D",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21975",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7024C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "146.098873%",
    x2: "50%",
    y2: "-45.1596833%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C74C4D",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21975",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7024C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "658.140556%",
    x2: "50%",
    y2: "-140.029283%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C74C4D",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21975",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7024C4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/insta",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8502706,0 L7.14972942,0 C3.207352,0 0,3.207352 0,7.14972942 L0,16.8502706 C0,20.792648 3.207352,24 7.14972942,24 L16.8502706,24 C20.792648,24 24,20.792648 24,16.8502706 L24,7.14972942 C24,3.207352 20.7926044,0 16.8502706,0 Z M21.5856009,16.8502706 C21.5856009,19.4654994 19.4654994,21.5856009 16.8502706,21.5856009 L7.14972942,21.5856009 C4.53450059,21.5856009 2.41439911,19.4654994 2.41439911,16.8502706 L2.41439911,7.14972942 C2.41439911,4.53445704 4.53450059,2.41439911 7.14972942,2.41439911 L16.8502706,2.41439911 C19.4654994,2.41439911 21.5856009,4.53445704 21.5856009,7.14972942 L21.5856009,16.8502706 L21.5856009,16.8502706 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C8.69159469,6 6,8.69160413 6,11.9999789 C6,15.3083538 8.69159469,18 12,18 C15.3084053,18 18,15.3083959 18,11.9999789 C18,8.69156203 15.3084053,6 12,6 Z M12,15.6662492 C9.97518892,15.6662492 8.33378474,14.0248392 8.33378474,12.0000211 C8.33378474,9.97520287 9.97523103,8.33379293 12,8.33379293 C14.0248111,8.33379293 15.6662153,9.97520287 15.6662153,12.0000211 C15.6662153,14.0247971 14.024769,15.6662492 12,15.6662492 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    cx: 18.5,
    cy: 5.5,
    r: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.00a83ccc5b3d6876fc5fb8784e1d92a9.svg";
export { ForwardRef as ReactComponent };